define('xApi/configuration/routes',[], function () {

    return [
        {
            route: 'xapierror(/:backUrl)',
            moduleId: 'xApi/viewmodels/xAPIError',
            title: 'xAPI Error'
        }
    ];

});
